import { request } from '@/utils/request';

export function fetchDataAssetValueSummary(data: any) {
  return request({
    url: '/cdh/data/wheel/getDataAssetValueSummary',
    method: 'post',
    data,
  });
}

export function fetchValueSummarySelectOption() {
  return request({
    url: '/cdh/data/wheel/getValueSummarySelectOption',
    method: 'get',
  });
}
